import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/DashboardStyle.module.css';
import { Link,useNavigate } from 'react-router-dom';
import DashboardTitle from "./DashboardTitle";
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
import { getblogListUserFormData ,DeletePostListData} from "../../services/routes.services";
import constants from "../../services/constants"
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '../Styles/Button.module.css';
import Modal from 'react-bootstrap/Modal'
const PostListing = ()=>{
    const [getAllData, setGetAllData] = useState(null);
    const { isAuthenticated, user,token } = useSelector((state) => state.auth);
    const [postData, setPostData]= useState(null)
    const [deletePost, setDeletPost] = useState(false);

    const openPostHandler = (data) => {
        setPostData(data);
        setDeletPost(true);
    };
    const closePostHandler = () => {
        setDeletPost(false);
        setPostData(null);
    };

    const navigate = useNavigate();
    useEffect(() => {
        blogListingApi()
                   
    }, []);
    const blogListingApi=()=>{
        getblogListUserFormData(token)
            .then((res) => {
                setGetAllData(res.data.blogs);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const handleEditPage=(data)=>{
        navigate("/post-create", { state: { data: data } });
    }

    const handleDeleteListing=(data)=>{
        DeletePostListData(data._id,token)
              .then((res) => {
             
                if(res.status===200){
                toast.success(res.data.message, {
                       position: "top-right",
                        
                    type: 'success'
                });
               
            }else{
                toast.error(res.data.message, {
                    position: "top-right",
                       type: 'error'
                 });
            }
            blogListingApi();
                   })
              .catch((error) => {
                  console.log(error);
              })
              .finally(() => {
                closePostHandler(); 
            });
            
    }

    return( 
        <div><DashBoardLeftProfileMenu/>
        <ToastContainer/>
         <div className={'containerStyla  ' + Style.Dashboardscreen +" "+Style.BussinesList}>
            <Container>
                <DashboardTitle title="Posts Listing" membertype="Non Member" />
                <Row className={Style.space}>
            <Col lg={6} className={Style.order2}>
                <h3 className={Style.dashboardSubTitle}>YOUR POSTS LISTINGS</h3>
                {getAllData && getAllData.map((blogs)=>{
                return(
                <div className={Style.jobList} key={blogs._id}>
                    <figure><img alt={blogs.title} src={constants.IMAGE_BASE_URL_WITHOUT_UPLOAD+'/'+blogs.image} /></figure>
                    
                    {blogs.title && (<h4>{blogs.title}</h4>)}
                   
                    {blogs.description && (<p> {blogs.description}</p>)}
                    <ul>
                    <li><a href="#" onClick={(e) => {e.preventDefault();handleEditPage(blogs)}}>Edit</a></li>
                    <li><a href="#" onClick={(e) => {e.preventDefault();openPostHandler(blogs)}}>Delete Listing</a> 
                        <Modal className='deleteContant' show={deletePost} onHide={closePostHandler} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                            <Modal.Body><p>Are you sure you want to delete this listing?</p></Modal.Body>
                            <Modal.Footer>
                                <button type="button" className={Button.brownBorderBtn} onClick={closePostHandler}>No</button>
                                <button type="button" className={Button.greenBtn} onClick={() => handleDeleteListing(postData)} autoFocus>Yes</button>
                            </Modal.Footer>
                        </Modal>
                    </li>
                        
                    </ul>                        
                </div> )})} 
              
                
            </Col>
            <Col lg={6} className={Style.paddL + " " + Style.order1}>
                <div className={Style.addJobList}>
                    <h4>Create New Post</h4>
                    <Link to="/post-create" className={Style.greenBtn} >Click Here</Link>
                </div>
            </Col>
            </Row>
            </Container>
        </div>
        </div>
        )
    }
    
    export default PostListing;